/**
 * Maps API error codes (attached to thrown Errors as `.code` by the http
 * layer) to human-friendly messages, so dialogs can show something useful
 * instead of a raw "409 Conflict".
 */
const FRIENDLY: Record<string, string> = {
  slug_already_exists: "That premise ID is already taken.",
  invalid_slug: "Invalid ID - lowercase letters, numbers and hyphens only.",
  company_already_exists: "A company with that name already exists.",
  user_already_exists: "A user with that email already exists.",
  invite_already_pending: "There's already a pending invite for that email.",
  password_too_short: "Password must be at least 8 characters.",
  missing_fields: "Please fill in all required fields.",
  missing_name: "Please enter a name.",
  duplicate_or_invalid:
    "That name is already taken, or the details are invalid.",
  room_already_taken: "That room is already taken.",
  has_premises:
    "This company still has premises - reassign or delete them first.",
};

/** The structured error code attached by the http layer, if any. */
export function errorCode(e: unknown): string | undefined {
  return typeof e === "object" && e !== null
    ? (e as { code?: string }).code
    : undefined;
}

/** A friendly message for an API error, falling back to its raw message. */
export function friendlyError(e: unknown, fallback?: string): string {
  const code = errorCode(e);
  if (code && FRIENDLY[code]) return FRIENDLY[code];
  if (fallback) return fallback;
  return e instanceof Error ? e.message : String(e);
}
